<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Portal-Document-Complaint-Upload",
  short_name: "Upload Complaint Document",
  path: "upload",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
